<template>
    <div id="app">
        <Layout/>
    </div>
</template>

<script>
    export default {
        name: 'app',
        components: {
            'Layout': () => import('./components/Layout')
        },
        methods: {}
    }
</script>

<style>
    @import '~ant-design-vue/dist/antd.css';
    @import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400,700,800&display=swap');
    @import '~bootstrap/dist/css/bootstrap.css';
    @import url('https://fonts.googleapis.com/css?family=Hind+Siliguri:300,400,500,700&display=swap');

    #app {
        font-family: OpenSans, 'Hind Siliguri', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
    }
    .page-link:focus {
        box-shadow: 0 0 14px 0 rgba(38, 143, 255, 0.5)!important;
    }
    .btn.btn-primary:focus {
        box-shadow: 0 0 14px 0 rgba(38, 143, 255, 0.5);
    }

    .form-control:focus, .form-control:active {
        box-shadow: 0 0 8px 0 rgba(0, 123, 255, 0.25)!important;
    }

    .arrow-btn.btn-primary.dropdown-toggle:focus,
    .arrow-btn.btn-primary.dropdown-toggle:focus:active {
        box-shadow: none !important;
    }

    .partial-container {
        width: 900px;
    }


</style>
